import axios from 'axios';

import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';

import configs from '../configs/environments';

const gmapsReqHandler = {

  getDistance: (origin: string, destination: string): Promise<ApiResponse<number>> => {

    return genericApi.get(`distance?origin=${origin}&destination=${destination}`);
  },
  getGeoCode: (address: string): Promise<{ data: { error_message: string, results: { geometry: { location: { lat: number, lng: number } } }[], status: string } }> => {

    return axios.get(`https://maps.google.com/maps/api/geocode/json?key=${configs.googleMapsApiKey}&address=${address}`);
  }
};

export default gmapsReqHandler;